
import React from 'react';
import { X } from 'lucide-react';

interface MobileMenuHeaderProps {
  onClose: () => void;
}

export const MobileMenuHeader: React.FC<MobileMenuHeaderProps> = ({ onClose }) => {
  return (
    <div className="sticky top-0 z-10 px-4 pt-6 pb-3 border-b border-gray-200 bg-white chrome-optimize flex items-center justify-between" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
      <span className="text-lg font-medium text-gray-900" id="menu-title">Menu</span>
      <button
        onClick={onClose}
        className="p-2 rounded-md text-muted-foreground hover:text-gray-500 hover:bg-gray-100 transition"
        style={{ minWidth: 44, minHeight: 44 }}
        aria-label="Close mobile menu"
      >
        <X className="h-6 w-6" aria-hidden="true" />
      </button>
    </div>
  );
};
